import styled from "styled-components";
import {
	RATypography,
	RATextInput,
	RACheckbox,
	RAImage,
	RAButtonSecondary,
	RAButtonPrimary,
} from "@/components/customs";
import { Row, Col, Divider, Grid } from "antd";
import { IconBringOversizeLuggage, IconBringPets, IconInterestEmptyLegs } from "@/assets/images";
const { useBreakpoint } = Grid;

export function FormRequestFlightAdditionalInfo({ data = {}, onChange, onNext, onBack }) {
	const screens = useBreakpoint();
	const { note = "", additional_info = {} } = data;

	const _renderNote = () => {
		return (
			<WrapperNote>
				<RATypography variant="body3" color="#595959">
					Additional Requests
				</RATypography>
				<RATextInput
					type="textarea"
					placeholder="Enter your additional requests"
					value={note}
					onChange={(val) => onChange({ ...data, note: val })}
				/>
			</WrapperNote>
		);
	};

	const _renderAdditionalServices = () => {
		return (
			<WrapperAdditionalServices>
				<RequestAdditionalServices
					title="I’m bringing a pet"
					description="Please provide details so we can ensure a comfortable journey for your furry friend."
					active={additional_info?.is_bring_pet}
					onChange={(val) => {
						onChange({
							...data,
							additional_info: {
								...data?.additional_info,
								is_bring_pet: val,
							},
						});
					}}
					icon={IconBringPets}
				/>
				<RequestAdditionalServices
					title="I’m bringing oversized luggage"
					description="Let us know the dimensions, so we can accommodate your larger items seamlessly."
					active={additional_info?.is_bring_oversize_luggage}
					onChange={(val) => {
						onChange({
							...data,
							additional_info: {
								...data?.additional_info,
								is_bring_oversize_luggage: val,
							},
						});
					}}
					icon={IconBringOversizeLuggage}
				/>
				<RequestAdditionalServices
					title="I’m interested in empty legs"
					description="Discover potential savings by booking flights on aircraft returning empty."
					active={additional_info?.is_interest_empty_leg}
					onChange={(val) => {
						onChange({
							...data,
							additional_info: {
								...data?.additional_info,
								is_interest_empty_leg: val,
							},
						});
					}}
					icon={IconInterestEmptyLegs}
				/>
			</WrapperAdditionalServices>
		);
	};

	return (
		<ContainerRequestFlight>
			<Row>
				<Col md={24}>
					<WrapperContent>
						<RATypography variant={screens.xs ? "h4" : "h3"}>Additional Info</RATypography>
					</WrapperContent>
					<RATypography variant="body3" top="12px" color="#595959">
						Please kindly provide us with any details or special requests regarding your unique travel
						needs.
					</RATypography>
				</Col>
			</Row>
			<Divider />
			{_renderNote()}
			{_renderAdditionalServices()}
			<Row gutter={[20, 12]} justify="center" align="middle" style={{ marginTop: "30px" }}>
				<ButtonCol xs={12}>
					<RAButtonSecondary title="BACK" onClick={() => onBack()} width="100%" />
				</ButtonCol>
				<ButtonCol xs={12}>
					<RAButtonPrimary
						title="NEXT"
						onClick={() => onNext()}
						width="100%"
						data-testid="flightInfo_nextBtn"
					/>
				</ButtonCol>
			</Row>
		</ContainerRequestFlight>
	);
}

const RequestAdditionalServices = ({ active, onChange, icon, title = "", description = "" }) => (
	<WrapperOptionItem
		onClick={(e) => {
			e?.preventDefault();
			e?.stopPropagation();
			onChange(!active);
		}}
		active={active}
		wrap={false}
		align="middle"
	>
		<Col>
			<RACheckbox
				checked={active}
				onChange={(e) => {
					e?.preventDefault();
					e?.stopPropagation();
				}}
			/>
		</Col>
		<Col>
			<RAImage width="48px" height="48px" url={icon} />
		</Col>
		<Col style={{ marginLeft: 16 }}>
			<RATypography variant="sub-heading4" color="#222222">
				{title}
			</RATypography>
			<RATypography variant="body3" color="#595959" top="4px">
				{description}
			</RATypography>
		</Col>
	</WrapperOptionItem>
);

const ContainerRequestFlight = styled.div`
	width: "100%";
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
const WrapperNote = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const WrapperAdditionalServices = styled.div`
	margin-top: 30px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
const WrapperOptionItem = styled(Row)`
	padding: 16px 20px;
	width: 100%;
	min-height: 80px;
	border-radius: 10px;
	border: 1px solid #e9e8e8;
	cursor: pointer;
	${({ active }) =>
		active &&
		`
        border: 1px solid #FFB11A;
    `}
`;
const ButtonCol = styled(Col)`
	max-width: 180px;
	width: 100%;
`;
